import { Box, styled } from '@mui/material';

export const PDFPageSelectionControlsContainer = styled(Box)<{ $allowPageSelection: boolean; $isPopped?: boolean; }>(
  ({ theme, $allowPageSelection, $isPopped }) => ({
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    width: '100%',
    height: 'fit-content',
    gap: 2,
    flexWrap: 'wrap',
    position: $allowPageSelection ? 'sticky' : 'relative',
    top: $allowPageSelection ? 0 : undefined,
    zIndex: $allowPageSelection ? 10000 : undefined,
    ...(!$isPopped && { paddingLeft: theme.spacing(8) }),
  })
);
